import { render, staticRenderFns } from "./form-textarea.vue?vue&type=template&id=b08bce88"
import script from "./form-textarea.vue?vue&type=script&lang=js"
export * from "./form-textarea.vue?vue&type=script&lang=js"
import style0 from "./form-textarea.vue?vue&type=style&index=0&id=b08bce88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports